export default __webpack_public_path__ + "static/media/AKM_8.24fd8d50.png";